import { Injectable } from "@angular/core";
import { LoginUser } from "@app/core/models/loginUser";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { JwtHelper, tokenNotExpired } from "angular2-jwt";
import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { AlertifyService } from "./alertify.service";
import { RegisterUser } from "@app/core/models/registerUser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class AuthService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private alertifyService: AlertifyService
  ) {}
  private API_URL = environment.API_URL;
  userToken: any;
  userName: any;
  decodedToken: any;
  jwtHelper: JwtHelper = new JwtHelper();
  TOKEN_KEY = "token";

  login(loginUser: LoginUser): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Access-Control-Allow-Origin", "*");
    return this.httpClient
      .post<any>(`${this.API_URL}auth/login`, loginUser, { headers: headers })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
    /*let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    this.httpClient
      .post(this.API_URL + "auth/login", loginUser, { headers: headers })
      .subscribe(data => {
        console.log("login", data);
        this.saveToken(data["sPassword"]);
        this.userToken = data["sPassword"];
        this.userName = data["sEmail"];
        this.saveUserName(data["sEmail"]);
        sessionStorage.setItem("firmTitle", data["sFirmTitle"]);
        this.decodedToken = this.jwtHelper.decodeToken(
          data["sPassword"].toString()
        );
        return true;
        //this.alertifyService.success("Sisteme giriş yapıldı");
        //this.router.navigateByUrl("/app-views/profile");
      }, () => {
        return false;
      });*/
  }

  register(registerUser: RegisterUser) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("token", "43543534redfgdfgsg");
    this.httpClient
      .post(this.API_URL + "auth/register", registerUser, { headers: headers })
      .subscribe((data) => {
        this.alertifyService.success(
          "Kayıt işleminiz başarıyla gerçekleştirildi."
        );
        this.router.navigateByUrl("/auth/login");
      });
  }

  forgotPassword(sEmail) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    this.httpClient
      .post(this.API_URL + "auth/forgotPassword", sEmail, { headers: headers })
      .subscribe((data) => {
        this.alertifyService.success(
          "Şifreniz sıfırlanmış ve e-posta adresinize gönderilmiştir."
        );
        this.router.navigateByUrl("/auth/login");
      });
  }

  deleteCurrentById(id) {
    this.httpClient
      .post(this.API_URL + "currents/delete", id)
      .subscribe((data) => {
        this.alertifyService.success("Cari hesap başarıyla silindi");
        this.router.navigateByUrl("/current");
      });
  }

  saveToken(token) {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  saveUserName(userName) {
    sessionStorage.setItem("userName", userName);
  }

  saveImage(imagePath) {
    localStorage.setItem("imagePath", imagePath);
  }

  logOut() {
    localStorage.removeItem(this.TOKEN_KEY);
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("firmTitle");
    sessionStorage.removeItem("imagePath");

    this.alertifyService.error("Sistemden çıkış yapıldı");

    window.location.reload(true);
  }

  loggedIn() {
    return tokenNotExpired(this.TOKEN_KEY);
  }

  get token() {
    return localStorage.getItem(this.TOKEN_KEY);
  }
  imageUrl() {
    return localStorage.getItem("imagePath");
  }

  getCurrentUserId() {
    return this.jwtHelper.decodeToken(this.token).nameid;
  }

  getCurrentUserRoles() {
    return this.jwtHelper.decodeToken(this.token).role;
  }

  getCurrentHasMembership() {
    return this.jwtHelper.decodeToken(this.token).HasMembership;
  }
}
